import(/* webpackMode: "eager" */ "/app/main/app/[locale]/project/p5/page.tsx");
